/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StickerPacksRouteImport } from './routes/sticker-packs'
import { Route as ConstraintsRouteImport } from './routes/constraints'
import { Route as AboutRouteImport } from './routes/about'
import { Route as MainRouteImport } from './routes/_main'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StickerPacksIndexRouteImport } from './routes/sticker-packs/index'
import { Route as SelectCommunityIndexRouteImport } from './routes/selectCommunity/index'
import { Route as PrivateIndexRouteImport } from './routes/private/index'
import { Route as PostIndexRouteImport } from './routes/post/index'
import { Route as Demo3IndexRouteImport } from './routes/demo3/index'
import { Route as Demo2IndexRouteImport } from './routes/demo2/index'
import { Route as StickerPacksStickerPackIdRouteImport } from './routes/sticker-packs/$stickerPackId'
import { Route as ContentPromptIdRouteImport } from './routes/content/$promptId'
import { Route as AuthRefreshRouteImport } from './routes/auth/refresh'
import { Route as StickerPacksStickerPackIdIndexRouteImport } from './routes/sticker-packs/$stickerPackId/index'
import { Route as PostCreateIndexRouteImport } from './routes/post/create/index'
import { Route as PostPostIdIndexRouteImport } from './routes/post/$postId/index'
import { Route as Demo2ItemIndexRouteImport } from './routes/demo2/item/index'
import { Route as ContentPromptIdIndexRouteImport } from './routes/content/$promptId/index'
import { Route as MainStickersIndexRouteImport } from './routes/_main/stickers/index'
import { Route as MainProfileIndexRouteImport } from './routes/_main/profile/index'
import { Route as MainCommunityIndexRouteImport } from './routes/_main/community/index'
import { Route as StickerPacksStickerPackIdSuccessRouteImport } from './routes/sticker-packs/$stickerPackId/success'
import { Route as StickerPacksStickerPackIdCheckoutRouteImport } from './routes/sticker-packs/$stickerPackId/checkout'
import { Route as MainProfileGenerationsTimelineRouteImport } from './routes/_main/profile/GenerationsTimeline'
import { Route as StickerPacksGeneratedIdIndexRouteImport } from './routes/sticker-packs/generated/$id/index'
import { Route as StickerPacksStickerPackIdSelectTierIndexRouteImport } from './routes/sticker-packs/$stickerPackId/select-tier/index'
import { Route as StickerPacksStickerPackIdSelectNftsIndexRouteImport } from './routes/sticker-packs/$stickerPackId/select-nfts/index'
import { Route as StickerPacksStickerPackIdReviewIndexRouteImport } from './routes/sticker-packs/$stickerPackId/review/index'
import { Route as StickerPacksStickerPackIdDetailsIndexRouteImport } from './routes/sticker-packs/$stickerPackId/details/index'
import { Route as PostCreateVideoIndexRouteImport } from './routes/post/create/video/index'
import { Route as PostCreateStickerIndexRouteImport } from './routes/post/create/sticker/index'
import { Route as PostCreateImageIndexRouteImport } from './routes/post/create/image/index'
import { Route as ContentPromptIdSelectNftsIndexRouteImport } from './routes/content/$promptId/select-nfts/index'
import { Route as ContentPromptIdInvitationIndexRouteImport } from './routes/content/$promptId/invitation/index'
import { Route as ContentPromptIdDetailsIndexRouteImport } from './routes/content/$promptId/details/index'
import { Route as MainProfilePurchasesIndexRouteImport } from './routes/_main/profile/purchases/index'
import { Route as MainProfileNotificationsIndexRouteImport } from './routes/_main/profile/notifications/index'
import { Route as MainProfileAdminIndexRouteImport } from './routes/_main/profile/admin/index'
import { Route as ContentPromptIdProcessingExecutionIdRouteImport } from './routes/content/$promptId/processing.$executionId'
import { Route as StickerPacksStickerPackIdProcessingExecutionIdIndexRouteImport } from './routes/sticker-packs/$stickerPackId/processing/$executionId/index'
import { Route as AuthDiscordV1CallbackIndexRouteImport } from './routes/auth/discord/v1/callback/index'
import { Route as MainProfileAdminPromptIndexRouteImport } from './routes/_main/profile/admin/prompt/index'
import { Route as MainProfileAdminPromptCreateRouteImport } from './routes/_main/profile/admin/prompt/create'
import { Route as MainProfileAdminPromptEditRouteRouteImport } from './routes/_main/profile/admin/prompt/edit/route'
import { Route as ContentPromptIdSuccessExecutionExecutionIdIndexRouteImport } from './routes/content/$promptId/success/execution/$executionId/index'
import { Route as MainProfileAdminPromptEditPromptIdRouteRouteImport } from './routes/_main/profile/admin/prompt/edit/$promptId/route'
import { Route as MainProfileAdminPromptEditPromptIdIndexRouteImport } from './routes/_main/profile/admin/prompt/edit/$promptId/index'

const StickerPacksRoute = StickerPacksRouteImport.update({
  id: '/sticker-packs',
  path: '/sticker-packs',
  getParentRoute: () => rootRouteImport,
} as any)
const ConstraintsRoute = ConstraintsRouteImport.update({
  id: '/constraints',
  path: '/constraints',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const MainRoute = MainRouteImport.update({
  id: '/_main',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StickerPacksIndexRoute = StickerPacksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StickerPacksRoute,
} as any)
const SelectCommunityIndexRoute = SelectCommunityIndexRouteImport.update({
  id: '/selectCommunity/',
  path: '/selectCommunity/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateIndexRoute = PrivateIndexRouteImport.update({
  id: '/private/',
  path: '/private/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostIndexRoute = PostIndexRouteImport.update({
  id: '/post/',
  path: '/post/',
  getParentRoute: () => rootRouteImport,
} as any)
const Demo3IndexRoute = Demo3IndexRouteImport.update({
  id: '/demo3/',
  path: '/demo3/',
  getParentRoute: () => rootRouteImport,
} as any)
const Demo2IndexRoute = Demo2IndexRouteImport.update({
  id: '/demo2/',
  path: '/demo2/',
  getParentRoute: () => rootRouteImport,
} as any)
const StickerPacksStickerPackIdRoute =
  StickerPacksStickerPackIdRouteImport.update({
    id: '/$stickerPackId',
    path: '/$stickerPackId',
    getParentRoute: () => StickerPacksRoute,
  } as any)
const ContentPromptIdRoute = ContentPromptIdRouteImport.update({
  id: '/content/$promptId',
  path: '/content/$promptId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRefreshRoute = AuthRefreshRouteImport.update({
  id: '/auth/refresh',
  path: '/auth/refresh',
  getParentRoute: () => rootRouteImport,
} as any)
const StickerPacksStickerPackIdIndexRoute =
  StickerPacksStickerPackIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StickerPacksStickerPackIdRoute,
  } as any)
const PostCreateIndexRoute = PostCreateIndexRouteImport.update({
  id: '/post/create/',
  path: '/post/create/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostPostIdIndexRoute = PostPostIdIndexRouteImport.update({
  id: '/post/$postId/',
  path: '/post/$postId/',
  getParentRoute: () => rootRouteImport,
} as any)
const Demo2ItemIndexRoute = Demo2ItemIndexRouteImport.update({
  id: '/demo2/item/',
  path: '/demo2/item/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentPromptIdIndexRoute = ContentPromptIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContentPromptIdRoute,
} as any)
const MainStickersIndexRoute = MainStickersIndexRouteImport.update({
  id: '/stickers/',
  path: '/stickers/',
  getParentRoute: () => MainRoute,
} as any)
const MainProfileIndexRoute = MainProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => MainRoute,
} as any)
const MainCommunityIndexRoute = MainCommunityIndexRouteImport.update({
  id: '/community/',
  path: '/community/',
  getParentRoute: () => MainRoute,
} as any)
const StickerPacksStickerPackIdSuccessRoute =
  StickerPacksStickerPackIdSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => StickerPacksStickerPackIdRoute,
  } as any)
const StickerPacksStickerPackIdCheckoutRoute =
  StickerPacksStickerPackIdCheckoutRouteImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => StickerPacksStickerPackIdRoute,
  } as any)
const MainProfileGenerationsTimelineRoute =
  MainProfileGenerationsTimelineRouteImport.update({
    id: '/profile/GenerationsTimeline',
    path: '/profile/GenerationsTimeline',
    getParentRoute: () => MainRoute,
  } as any)
const StickerPacksGeneratedIdIndexRoute =
  StickerPacksGeneratedIdIndexRouteImport.update({
    id: '/generated/$id/',
    path: '/generated/$id/',
    getParentRoute: () => StickerPacksRoute,
  } as any)
const StickerPacksStickerPackIdSelectTierIndexRoute =
  StickerPacksStickerPackIdSelectTierIndexRouteImport.update({
    id: '/select-tier/',
    path: '/select-tier/',
    getParentRoute: () => StickerPacksStickerPackIdRoute,
  } as any)
const StickerPacksStickerPackIdSelectNftsIndexRoute =
  StickerPacksStickerPackIdSelectNftsIndexRouteImport.update({
    id: '/select-nfts/',
    path: '/select-nfts/',
    getParentRoute: () => StickerPacksStickerPackIdRoute,
  } as any)
const StickerPacksStickerPackIdReviewIndexRoute =
  StickerPacksStickerPackIdReviewIndexRouteImport.update({
    id: '/review/',
    path: '/review/',
    getParentRoute: () => StickerPacksStickerPackIdRoute,
  } as any)
const StickerPacksStickerPackIdDetailsIndexRoute =
  StickerPacksStickerPackIdDetailsIndexRouteImport.update({
    id: '/details/',
    path: '/details/',
    getParentRoute: () => StickerPacksStickerPackIdRoute,
  } as any)
const PostCreateVideoIndexRoute = PostCreateVideoIndexRouteImport.update({
  id: '/post/create/video/',
  path: '/post/create/video/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostCreateStickerIndexRoute = PostCreateStickerIndexRouteImport.update({
  id: '/post/create/sticker/',
  path: '/post/create/sticker/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostCreateImageIndexRoute = PostCreateImageIndexRouteImport.update({
  id: '/post/create/image/',
  path: '/post/create/image/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentPromptIdSelectNftsIndexRoute =
  ContentPromptIdSelectNftsIndexRouteImport.update({
    id: '/select-nfts/',
    path: '/select-nfts/',
    getParentRoute: () => ContentPromptIdRoute,
  } as any)
const ContentPromptIdInvitationIndexRoute =
  ContentPromptIdInvitationIndexRouteImport.update({
    id: '/invitation/',
    path: '/invitation/',
    getParentRoute: () => ContentPromptIdRoute,
  } as any)
const ContentPromptIdDetailsIndexRoute =
  ContentPromptIdDetailsIndexRouteImport.update({
    id: '/details/',
    path: '/details/',
    getParentRoute: () => ContentPromptIdRoute,
  } as any)
const MainProfilePurchasesIndexRoute =
  MainProfilePurchasesIndexRouteImport.update({
    id: '/profile/purchases/',
    path: '/profile/purchases/',
    getParentRoute: () => MainRoute,
  } as any)
const MainProfileNotificationsIndexRoute =
  MainProfileNotificationsIndexRouteImport.update({
    id: '/profile/notifications/',
    path: '/profile/notifications/',
    getParentRoute: () => MainRoute,
  } as any)
const MainProfileAdminIndexRoute = MainProfileAdminIndexRouteImport.update({
  id: '/profile/admin/',
  path: '/profile/admin/',
  getParentRoute: () => MainRoute,
} as any)
const ContentPromptIdProcessingExecutionIdRoute =
  ContentPromptIdProcessingExecutionIdRouteImport.update({
    id: '/processing/$executionId',
    path: '/processing/$executionId',
    getParentRoute: () => ContentPromptIdRoute,
  } as any)
const StickerPacksStickerPackIdProcessingExecutionIdIndexRoute =
  StickerPacksStickerPackIdProcessingExecutionIdIndexRouteImport.update({
    id: '/processing/$executionId/',
    path: '/processing/$executionId/',
    getParentRoute: () => StickerPacksStickerPackIdRoute,
  } as any)
const AuthDiscordV1CallbackIndexRoute =
  AuthDiscordV1CallbackIndexRouteImport.update({
    id: '/auth/discord/v1/callback/',
    path: '/auth/discord/v1/callback/',
    getParentRoute: () => rootRouteImport,
  } as any)
const MainProfileAdminPromptIndexRoute =
  MainProfileAdminPromptIndexRouteImport.update({
    id: '/profile/admin/prompt/',
    path: '/profile/admin/prompt/',
    getParentRoute: () => MainRoute,
  } as any)
const MainProfileAdminPromptCreateRoute =
  MainProfileAdminPromptCreateRouteImport.update({
    id: '/profile/admin/prompt/create',
    path: '/profile/admin/prompt/create',
    getParentRoute: () => MainRoute,
  } as any)
const MainProfileAdminPromptEditRouteRoute =
  MainProfileAdminPromptEditRouteRouteImport.update({
    id: '/profile/admin/prompt/edit',
    path: '/profile/admin/prompt/edit',
    getParentRoute: () => MainRoute,
  } as any)
const ContentPromptIdSuccessExecutionExecutionIdIndexRoute =
  ContentPromptIdSuccessExecutionExecutionIdIndexRouteImport.update({
    id: '/success/execution/$executionId/',
    path: '/success/execution/$executionId/',
    getParentRoute: () => ContentPromptIdRoute,
  } as any)
const MainProfileAdminPromptEditPromptIdRouteRoute =
  MainProfileAdminPromptEditPromptIdRouteRouteImport.update({
    id: '/$promptId',
    path: '/$promptId',
    getParentRoute: () => MainProfileAdminPromptEditRouteRoute,
  } as any)
const MainProfileAdminPromptEditPromptIdIndexRoute =
  MainProfileAdminPromptEditPromptIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MainProfileAdminPromptEditPromptIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/constraints': typeof ConstraintsRoute
  '/sticker-packs': typeof StickerPacksRouteWithChildren
  '/auth/refresh': typeof AuthRefreshRoute
  '/content/$promptId': typeof ContentPromptIdRouteWithChildren
  '/sticker-packs/$stickerPackId': typeof StickerPacksStickerPackIdRouteWithChildren
  '/demo2': typeof Demo2IndexRoute
  '/demo3': typeof Demo3IndexRoute
  '/post': typeof PostIndexRoute
  '/private': typeof PrivateIndexRoute
  '/selectCommunity': typeof SelectCommunityIndexRoute
  '/sticker-packs/': typeof StickerPacksIndexRoute
  '/profile/GenerationsTimeline': typeof MainProfileGenerationsTimelineRoute
  '/sticker-packs/$stickerPackId/checkout': typeof StickerPacksStickerPackIdCheckoutRoute
  '/sticker-packs/$stickerPackId/success': typeof StickerPacksStickerPackIdSuccessRoute
  '/community': typeof MainCommunityIndexRoute
  '/profile': typeof MainProfileIndexRoute
  '/stickers': typeof MainStickersIndexRoute
  '/content/$promptId/': typeof ContentPromptIdIndexRoute
  '/demo2/item': typeof Demo2ItemIndexRoute
  '/post/$postId': typeof PostPostIdIndexRoute
  '/post/create': typeof PostCreateIndexRoute
  '/sticker-packs/$stickerPackId/': typeof StickerPacksStickerPackIdIndexRoute
  '/content/$promptId/processing/$executionId': typeof ContentPromptIdProcessingExecutionIdRoute
  '/profile/admin': typeof MainProfileAdminIndexRoute
  '/profile/notifications': typeof MainProfileNotificationsIndexRoute
  '/profile/purchases': typeof MainProfilePurchasesIndexRoute
  '/content/$promptId/details': typeof ContentPromptIdDetailsIndexRoute
  '/content/$promptId/invitation': typeof ContentPromptIdInvitationIndexRoute
  '/content/$promptId/select-nfts': typeof ContentPromptIdSelectNftsIndexRoute
  '/post/create/image': typeof PostCreateImageIndexRoute
  '/post/create/sticker': typeof PostCreateStickerIndexRoute
  '/post/create/video': typeof PostCreateVideoIndexRoute
  '/sticker-packs/$stickerPackId/details': typeof StickerPacksStickerPackIdDetailsIndexRoute
  '/sticker-packs/$stickerPackId/review': typeof StickerPacksStickerPackIdReviewIndexRoute
  '/sticker-packs/$stickerPackId/select-nfts': typeof StickerPacksStickerPackIdSelectNftsIndexRoute
  '/sticker-packs/$stickerPackId/select-tier': typeof StickerPacksStickerPackIdSelectTierIndexRoute
  '/sticker-packs/generated/$id': typeof StickerPacksGeneratedIdIndexRoute
  '/profile/admin/prompt/edit': typeof MainProfileAdminPromptEditRouteRouteWithChildren
  '/profile/admin/prompt/create': typeof MainProfileAdminPromptCreateRoute
  '/profile/admin/prompt': typeof MainProfileAdminPromptIndexRoute
  '/auth/discord/v1/callback': typeof AuthDiscordV1CallbackIndexRoute
  '/sticker-packs/$stickerPackId/processing/$executionId': typeof StickerPacksStickerPackIdProcessingExecutionIdIndexRoute
  '/profile/admin/prompt/edit/$promptId': typeof MainProfileAdminPromptEditPromptIdRouteRouteWithChildren
  '/content/$promptId/success/execution/$executionId': typeof ContentPromptIdSuccessExecutionExecutionIdIndexRoute
  '/profile/admin/prompt/edit/$promptId/': typeof MainProfileAdminPromptEditPromptIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/constraints': typeof ConstraintsRoute
  '/auth/refresh': typeof AuthRefreshRoute
  '/demo2': typeof Demo2IndexRoute
  '/demo3': typeof Demo3IndexRoute
  '/post': typeof PostIndexRoute
  '/private': typeof PrivateIndexRoute
  '/selectCommunity': typeof SelectCommunityIndexRoute
  '/sticker-packs': typeof StickerPacksIndexRoute
  '/profile/GenerationsTimeline': typeof MainProfileGenerationsTimelineRoute
  '/sticker-packs/$stickerPackId/checkout': typeof StickerPacksStickerPackIdCheckoutRoute
  '/sticker-packs/$stickerPackId/success': typeof StickerPacksStickerPackIdSuccessRoute
  '/community': typeof MainCommunityIndexRoute
  '/profile': typeof MainProfileIndexRoute
  '/stickers': typeof MainStickersIndexRoute
  '/content/$promptId': typeof ContentPromptIdIndexRoute
  '/demo2/item': typeof Demo2ItemIndexRoute
  '/post/$postId': typeof PostPostIdIndexRoute
  '/post/create': typeof PostCreateIndexRoute
  '/sticker-packs/$stickerPackId': typeof StickerPacksStickerPackIdIndexRoute
  '/content/$promptId/processing/$executionId': typeof ContentPromptIdProcessingExecutionIdRoute
  '/profile/admin': typeof MainProfileAdminIndexRoute
  '/profile/notifications': typeof MainProfileNotificationsIndexRoute
  '/profile/purchases': typeof MainProfilePurchasesIndexRoute
  '/content/$promptId/details': typeof ContentPromptIdDetailsIndexRoute
  '/content/$promptId/invitation': typeof ContentPromptIdInvitationIndexRoute
  '/content/$promptId/select-nfts': typeof ContentPromptIdSelectNftsIndexRoute
  '/post/create/image': typeof PostCreateImageIndexRoute
  '/post/create/sticker': typeof PostCreateStickerIndexRoute
  '/post/create/video': typeof PostCreateVideoIndexRoute
  '/sticker-packs/$stickerPackId/details': typeof StickerPacksStickerPackIdDetailsIndexRoute
  '/sticker-packs/$stickerPackId/review': typeof StickerPacksStickerPackIdReviewIndexRoute
  '/sticker-packs/$stickerPackId/select-nfts': typeof StickerPacksStickerPackIdSelectNftsIndexRoute
  '/sticker-packs/$stickerPackId/select-tier': typeof StickerPacksStickerPackIdSelectTierIndexRoute
  '/sticker-packs/generated/$id': typeof StickerPacksGeneratedIdIndexRoute
  '/profile/admin/prompt/edit': typeof MainProfileAdminPromptEditRouteRouteWithChildren
  '/profile/admin/prompt/create': typeof MainProfileAdminPromptCreateRoute
  '/profile/admin/prompt': typeof MainProfileAdminPromptIndexRoute
  '/auth/discord/v1/callback': typeof AuthDiscordV1CallbackIndexRoute
  '/sticker-packs/$stickerPackId/processing/$executionId': typeof StickerPacksStickerPackIdProcessingExecutionIdIndexRoute
  '/content/$promptId/success/execution/$executionId': typeof ContentPromptIdSuccessExecutionExecutionIdIndexRoute
  '/profile/admin/prompt/edit/$promptId': typeof MainProfileAdminPromptEditPromptIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_main': typeof MainRouteWithChildren
  '/about': typeof AboutRoute
  '/constraints': typeof ConstraintsRoute
  '/sticker-packs': typeof StickerPacksRouteWithChildren
  '/auth/refresh': typeof AuthRefreshRoute
  '/content/$promptId': typeof ContentPromptIdRouteWithChildren
  '/sticker-packs/$stickerPackId': typeof StickerPacksStickerPackIdRouteWithChildren
  '/demo2/': typeof Demo2IndexRoute
  '/demo3/': typeof Demo3IndexRoute
  '/post/': typeof PostIndexRoute
  '/private/': typeof PrivateIndexRoute
  '/selectCommunity/': typeof SelectCommunityIndexRoute
  '/sticker-packs/': typeof StickerPacksIndexRoute
  '/_main/profile/GenerationsTimeline': typeof MainProfileGenerationsTimelineRoute
  '/sticker-packs/$stickerPackId/checkout': typeof StickerPacksStickerPackIdCheckoutRoute
  '/sticker-packs/$stickerPackId/success': typeof StickerPacksStickerPackIdSuccessRoute
  '/_main/community/': typeof MainCommunityIndexRoute
  '/_main/profile/': typeof MainProfileIndexRoute
  '/_main/stickers/': typeof MainStickersIndexRoute
  '/content/$promptId/': typeof ContentPromptIdIndexRoute
  '/demo2/item/': typeof Demo2ItemIndexRoute
  '/post/$postId/': typeof PostPostIdIndexRoute
  '/post/create/': typeof PostCreateIndexRoute
  '/sticker-packs/$stickerPackId/': typeof StickerPacksStickerPackIdIndexRoute
  '/content/$promptId/processing/$executionId': typeof ContentPromptIdProcessingExecutionIdRoute
  '/_main/profile/admin/': typeof MainProfileAdminIndexRoute
  '/_main/profile/notifications/': typeof MainProfileNotificationsIndexRoute
  '/_main/profile/purchases/': typeof MainProfilePurchasesIndexRoute
  '/content/$promptId/details/': typeof ContentPromptIdDetailsIndexRoute
  '/content/$promptId/invitation/': typeof ContentPromptIdInvitationIndexRoute
  '/content/$promptId/select-nfts/': typeof ContentPromptIdSelectNftsIndexRoute
  '/post/create/image/': typeof PostCreateImageIndexRoute
  '/post/create/sticker/': typeof PostCreateStickerIndexRoute
  '/post/create/video/': typeof PostCreateVideoIndexRoute
  '/sticker-packs/$stickerPackId/details/': typeof StickerPacksStickerPackIdDetailsIndexRoute
  '/sticker-packs/$stickerPackId/review/': typeof StickerPacksStickerPackIdReviewIndexRoute
  '/sticker-packs/$stickerPackId/select-nfts/': typeof StickerPacksStickerPackIdSelectNftsIndexRoute
  '/sticker-packs/$stickerPackId/select-tier/': typeof StickerPacksStickerPackIdSelectTierIndexRoute
  '/sticker-packs/generated/$id/': typeof StickerPacksGeneratedIdIndexRoute
  '/_main/profile/admin/prompt/edit': typeof MainProfileAdminPromptEditRouteRouteWithChildren
  '/_main/profile/admin/prompt/create': typeof MainProfileAdminPromptCreateRoute
  '/_main/profile/admin/prompt/': typeof MainProfileAdminPromptIndexRoute
  '/auth/discord/v1/callback/': typeof AuthDiscordV1CallbackIndexRoute
  '/sticker-packs/$stickerPackId/processing/$executionId/': typeof StickerPacksStickerPackIdProcessingExecutionIdIndexRoute
  '/_main/profile/admin/prompt/edit/$promptId': typeof MainProfileAdminPromptEditPromptIdRouteRouteWithChildren
  '/content/$promptId/success/execution/$executionId/': typeof ContentPromptIdSuccessExecutionExecutionIdIndexRoute
  '/_main/profile/admin/prompt/edit/$promptId/': typeof MainProfileAdminPromptEditPromptIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/constraints'
    | '/sticker-packs'
    | '/auth/refresh'
    | '/content/$promptId'
    | '/sticker-packs/$stickerPackId'
    | '/demo2'
    | '/demo3'
    | '/post'
    | '/private'
    | '/selectCommunity'
    | '/sticker-packs/'
    | '/profile/GenerationsTimeline'
    | '/sticker-packs/$stickerPackId/checkout'
    | '/sticker-packs/$stickerPackId/success'
    | '/community'
    | '/profile'
    | '/stickers'
    | '/content/$promptId/'
    | '/demo2/item'
    | '/post/$postId'
    | '/post/create'
    | '/sticker-packs/$stickerPackId/'
    | '/content/$promptId/processing/$executionId'
    | '/profile/admin'
    | '/profile/notifications'
    | '/profile/purchases'
    | '/content/$promptId/details'
    | '/content/$promptId/invitation'
    | '/content/$promptId/select-nfts'
    | '/post/create/image'
    | '/post/create/sticker'
    | '/post/create/video'
    | '/sticker-packs/$stickerPackId/details'
    | '/sticker-packs/$stickerPackId/review'
    | '/sticker-packs/$stickerPackId/select-nfts'
    | '/sticker-packs/$stickerPackId/select-tier'
    | '/sticker-packs/generated/$id'
    | '/profile/admin/prompt/edit'
    | '/profile/admin/prompt/create'
    | '/profile/admin/prompt'
    | '/auth/discord/v1/callback'
    | '/sticker-packs/$stickerPackId/processing/$executionId'
    | '/profile/admin/prompt/edit/$promptId'
    | '/content/$promptId/success/execution/$executionId'
    | '/profile/admin/prompt/edit/$promptId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/constraints'
    | '/auth/refresh'
    | '/demo2'
    | '/demo3'
    | '/post'
    | '/private'
    | '/selectCommunity'
    | '/sticker-packs'
    | '/profile/GenerationsTimeline'
    | '/sticker-packs/$stickerPackId/checkout'
    | '/sticker-packs/$stickerPackId/success'
    | '/community'
    | '/profile'
    | '/stickers'
    | '/content/$promptId'
    | '/demo2/item'
    | '/post/$postId'
    | '/post/create'
    | '/sticker-packs/$stickerPackId'
    | '/content/$promptId/processing/$executionId'
    | '/profile/admin'
    | '/profile/notifications'
    | '/profile/purchases'
    | '/content/$promptId/details'
    | '/content/$promptId/invitation'
    | '/content/$promptId/select-nfts'
    | '/post/create/image'
    | '/post/create/sticker'
    | '/post/create/video'
    | '/sticker-packs/$stickerPackId/details'
    | '/sticker-packs/$stickerPackId/review'
    | '/sticker-packs/$stickerPackId/select-nfts'
    | '/sticker-packs/$stickerPackId/select-tier'
    | '/sticker-packs/generated/$id'
    | '/profile/admin/prompt/edit'
    | '/profile/admin/prompt/create'
    | '/profile/admin/prompt'
    | '/auth/discord/v1/callback'
    | '/sticker-packs/$stickerPackId/processing/$executionId'
    | '/content/$promptId/success/execution/$executionId'
    | '/profile/admin/prompt/edit/$promptId'
  id:
    | '__root__'
    | '/'
    | '/_main'
    | '/about'
    | '/constraints'
    | '/sticker-packs'
    | '/auth/refresh'
    | '/content/$promptId'
    | '/sticker-packs/$stickerPackId'
    | '/demo2/'
    | '/demo3/'
    | '/post/'
    | '/private/'
    | '/selectCommunity/'
    | '/sticker-packs/'
    | '/_main/profile/GenerationsTimeline'
    | '/sticker-packs/$stickerPackId/checkout'
    | '/sticker-packs/$stickerPackId/success'
    | '/_main/community/'
    | '/_main/profile/'
    | '/_main/stickers/'
    | '/content/$promptId/'
    | '/demo2/item/'
    | '/post/$postId/'
    | '/post/create/'
    | '/sticker-packs/$stickerPackId/'
    | '/content/$promptId/processing/$executionId'
    | '/_main/profile/admin/'
    | '/_main/profile/notifications/'
    | '/_main/profile/purchases/'
    | '/content/$promptId/details/'
    | '/content/$promptId/invitation/'
    | '/content/$promptId/select-nfts/'
    | '/post/create/image/'
    | '/post/create/sticker/'
    | '/post/create/video/'
    | '/sticker-packs/$stickerPackId/details/'
    | '/sticker-packs/$stickerPackId/review/'
    | '/sticker-packs/$stickerPackId/select-nfts/'
    | '/sticker-packs/$stickerPackId/select-tier/'
    | '/sticker-packs/generated/$id/'
    | '/_main/profile/admin/prompt/edit'
    | '/_main/profile/admin/prompt/create'
    | '/_main/profile/admin/prompt/'
    | '/auth/discord/v1/callback/'
    | '/sticker-packs/$stickerPackId/processing/$executionId/'
    | '/_main/profile/admin/prompt/edit/$promptId'
    | '/content/$promptId/success/execution/$executionId/'
    | '/_main/profile/admin/prompt/edit/$promptId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MainRoute: typeof MainRouteWithChildren
  AboutRoute: typeof AboutRoute
  ConstraintsRoute: typeof ConstraintsRoute
  StickerPacksRoute: typeof StickerPacksRouteWithChildren
  AuthRefreshRoute: typeof AuthRefreshRoute
  ContentPromptIdRoute: typeof ContentPromptIdRouteWithChildren
  Demo2IndexRoute: typeof Demo2IndexRoute
  Demo3IndexRoute: typeof Demo3IndexRoute
  PostIndexRoute: typeof PostIndexRoute
  PrivateIndexRoute: typeof PrivateIndexRoute
  SelectCommunityIndexRoute: typeof SelectCommunityIndexRoute
  Demo2ItemIndexRoute: typeof Demo2ItemIndexRoute
  PostPostIdIndexRoute: typeof PostPostIdIndexRoute
  PostCreateIndexRoute: typeof PostCreateIndexRoute
  PostCreateImageIndexRoute: typeof PostCreateImageIndexRoute
  PostCreateStickerIndexRoute: typeof PostCreateStickerIndexRoute
  PostCreateVideoIndexRoute: typeof PostCreateVideoIndexRoute
  AuthDiscordV1CallbackIndexRoute: typeof AuthDiscordV1CallbackIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sticker-packs': {
      id: '/sticker-packs'
      path: '/sticker-packs'
      fullPath: '/sticker-packs'
      preLoaderRoute: typeof StickerPacksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/constraints': {
      id: '/constraints'
      path: '/constraints'
      fullPath: '/constraints'
      preLoaderRoute: typeof ConstraintsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sticker-packs/': {
      id: '/sticker-packs/'
      path: '/'
      fullPath: '/sticker-packs/'
      preLoaderRoute: typeof StickerPacksIndexRouteImport
      parentRoute: typeof StickerPacksRoute
    }
    '/selectCommunity/': {
      id: '/selectCommunity/'
      path: '/selectCommunity'
      fullPath: '/selectCommunity'
      preLoaderRoute: typeof SelectCommunityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/private/': {
      id: '/private/'
      path: '/private'
      fullPath: '/private'
      preLoaderRoute: typeof PrivateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/post/': {
      id: '/post/'
      path: '/post'
      fullPath: '/post'
      preLoaderRoute: typeof PostIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo3/': {
      id: '/demo3/'
      path: '/demo3'
      fullPath: '/demo3'
      preLoaderRoute: typeof Demo3IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo2/': {
      id: '/demo2/'
      path: '/demo2'
      fullPath: '/demo2'
      preLoaderRoute: typeof Demo2IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sticker-packs/$stickerPackId': {
      id: '/sticker-packs/$stickerPackId'
      path: '/$stickerPackId'
      fullPath: '/sticker-packs/$stickerPackId'
      preLoaderRoute: typeof StickerPacksStickerPackIdRouteImport
      parentRoute: typeof StickerPacksRoute
    }
    '/content/$promptId': {
      id: '/content/$promptId'
      path: '/content/$promptId'
      fullPath: '/content/$promptId'
      preLoaderRoute: typeof ContentPromptIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/refresh': {
      id: '/auth/refresh'
      path: '/auth/refresh'
      fullPath: '/auth/refresh'
      preLoaderRoute: typeof AuthRefreshRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sticker-packs/$stickerPackId/': {
      id: '/sticker-packs/$stickerPackId/'
      path: '/'
      fullPath: '/sticker-packs/$stickerPackId/'
      preLoaderRoute: typeof StickerPacksStickerPackIdIndexRouteImport
      parentRoute: typeof StickerPacksStickerPackIdRoute
    }
    '/post/create/': {
      id: '/post/create/'
      path: '/post/create'
      fullPath: '/post/create'
      preLoaderRoute: typeof PostCreateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/post/$postId/': {
      id: '/post/$postId/'
      path: '/post/$postId'
      fullPath: '/post/$postId'
      preLoaderRoute: typeof PostPostIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo2/item/': {
      id: '/demo2/item/'
      path: '/demo2/item'
      fullPath: '/demo2/item'
      preLoaderRoute: typeof Demo2ItemIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/content/$promptId/': {
      id: '/content/$promptId/'
      path: '/'
      fullPath: '/content/$promptId/'
      preLoaderRoute: typeof ContentPromptIdIndexRouteImport
      parentRoute: typeof ContentPromptIdRoute
    }
    '/_main/stickers/': {
      id: '/_main/stickers/'
      path: '/stickers'
      fullPath: '/stickers'
      preLoaderRoute: typeof MainStickersIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/profile/': {
      id: '/_main/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof MainProfileIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/community/': {
      id: '/_main/community/'
      path: '/community'
      fullPath: '/community'
      preLoaderRoute: typeof MainCommunityIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/sticker-packs/$stickerPackId/success': {
      id: '/sticker-packs/$stickerPackId/success'
      path: '/success'
      fullPath: '/sticker-packs/$stickerPackId/success'
      preLoaderRoute: typeof StickerPacksStickerPackIdSuccessRouteImport
      parentRoute: typeof StickerPacksStickerPackIdRoute
    }
    '/sticker-packs/$stickerPackId/checkout': {
      id: '/sticker-packs/$stickerPackId/checkout'
      path: '/checkout'
      fullPath: '/sticker-packs/$stickerPackId/checkout'
      preLoaderRoute: typeof StickerPacksStickerPackIdCheckoutRouteImport
      parentRoute: typeof StickerPacksStickerPackIdRoute
    }
    '/_main/profile/GenerationsTimeline': {
      id: '/_main/profile/GenerationsTimeline'
      path: '/profile/GenerationsTimeline'
      fullPath: '/profile/GenerationsTimeline'
      preLoaderRoute: typeof MainProfileGenerationsTimelineRouteImport
      parentRoute: typeof MainRoute
    }
    '/sticker-packs/generated/$id/': {
      id: '/sticker-packs/generated/$id/'
      path: '/generated/$id'
      fullPath: '/sticker-packs/generated/$id'
      preLoaderRoute: typeof StickerPacksGeneratedIdIndexRouteImport
      parentRoute: typeof StickerPacksRoute
    }
    '/sticker-packs/$stickerPackId/select-tier/': {
      id: '/sticker-packs/$stickerPackId/select-tier/'
      path: '/select-tier'
      fullPath: '/sticker-packs/$stickerPackId/select-tier'
      preLoaderRoute: typeof StickerPacksStickerPackIdSelectTierIndexRouteImport
      parentRoute: typeof StickerPacksStickerPackIdRoute
    }
    '/sticker-packs/$stickerPackId/select-nfts/': {
      id: '/sticker-packs/$stickerPackId/select-nfts/'
      path: '/select-nfts'
      fullPath: '/sticker-packs/$stickerPackId/select-nfts'
      preLoaderRoute: typeof StickerPacksStickerPackIdSelectNftsIndexRouteImport
      parentRoute: typeof StickerPacksStickerPackIdRoute
    }
    '/sticker-packs/$stickerPackId/review/': {
      id: '/sticker-packs/$stickerPackId/review/'
      path: '/review'
      fullPath: '/sticker-packs/$stickerPackId/review'
      preLoaderRoute: typeof StickerPacksStickerPackIdReviewIndexRouteImport
      parentRoute: typeof StickerPacksStickerPackIdRoute
    }
    '/sticker-packs/$stickerPackId/details/': {
      id: '/sticker-packs/$stickerPackId/details/'
      path: '/details'
      fullPath: '/sticker-packs/$stickerPackId/details'
      preLoaderRoute: typeof StickerPacksStickerPackIdDetailsIndexRouteImport
      parentRoute: typeof StickerPacksStickerPackIdRoute
    }
    '/post/create/video/': {
      id: '/post/create/video/'
      path: '/post/create/video'
      fullPath: '/post/create/video'
      preLoaderRoute: typeof PostCreateVideoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/post/create/sticker/': {
      id: '/post/create/sticker/'
      path: '/post/create/sticker'
      fullPath: '/post/create/sticker'
      preLoaderRoute: typeof PostCreateStickerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/post/create/image/': {
      id: '/post/create/image/'
      path: '/post/create/image'
      fullPath: '/post/create/image'
      preLoaderRoute: typeof PostCreateImageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/content/$promptId/select-nfts/': {
      id: '/content/$promptId/select-nfts/'
      path: '/select-nfts'
      fullPath: '/content/$promptId/select-nfts'
      preLoaderRoute: typeof ContentPromptIdSelectNftsIndexRouteImport
      parentRoute: typeof ContentPromptIdRoute
    }
    '/content/$promptId/invitation/': {
      id: '/content/$promptId/invitation/'
      path: '/invitation'
      fullPath: '/content/$promptId/invitation'
      preLoaderRoute: typeof ContentPromptIdInvitationIndexRouteImport
      parentRoute: typeof ContentPromptIdRoute
    }
    '/content/$promptId/details/': {
      id: '/content/$promptId/details/'
      path: '/details'
      fullPath: '/content/$promptId/details'
      preLoaderRoute: typeof ContentPromptIdDetailsIndexRouteImport
      parentRoute: typeof ContentPromptIdRoute
    }
    '/_main/profile/purchases/': {
      id: '/_main/profile/purchases/'
      path: '/profile/purchases'
      fullPath: '/profile/purchases'
      preLoaderRoute: typeof MainProfilePurchasesIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/profile/notifications/': {
      id: '/_main/profile/notifications/'
      path: '/profile/notifications'
      fullPath: '/profile/notifications'
      preLoaderRoute: typeof MainProfileNotificationsIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/profile/admin/': {
      id: '/_main/profile/admin/'
      path: '/profile/admin'
      fullPath: '/profile/admin'
      preLoaderRoute: typeof MainProfileAdminIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/content/$promptId/processing/$executionId': {
      id: '/content/$promptId/processing/$executionId'
      path: '/processing/$executionId'
      fullPath: '/content/$promptId/processing/$executionId'
      preLoaderRoute: typeof ContentPromptIdProcessingExecutionIdRouteImport
      parentRoute: typeof ContentPromptIdRoute
    }
    '/sticker-packs/$stickerPackId/processing/$executionId/': {
      id: '/sticker-packs/$stickerPackId/processing/$executionId/'
      path: '/processing/$executionId'
      fullPath: '/sticker-packs/$stickerPackId/processing/$executionId'
      preLoaderRoute: typeof StickerPacksStickerPackIdProcessingExecutionIdIndexRouteImport
      parentRoute: typeof StickerPacksStickerPackIdRoute
    }
    '/auth/discord/v1/callback/': {
      id: '/auth/discord/v1/callback/'
      path: '/auth/discord/v1/callback'
      fullPath: '/auth/discord/v1/callback'
      preLoaderRoute: typeof AuthDiscordV1CallbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main/profile/admin/prompt/': {
      id: '/_main/profile/admin/prompt/'
      path: '/profile/admin/prompt'
      fullPath: '/profile/admin/prompt'
      preLoaderRoute: typeof MainProfileAdminPromptIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/profile/admin/prompt/create': {
      id: '/_main/profile/admin/prompt/create'
      path: '/profile/admin/prompt/create'
      fullPath: '/profile/admin/prompt/create'
      preLoaderRoute: typeof MainProfileAdminPromptCreateRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/profile/admin/prompt/edit': {
      id: '/_main/profile/admin/prompt/edit'
      path: '/profile/admin/prompt/edit'
      fullPath: '/profile/admin/prompt/edit'
      preLoaderRoute: typeof MainProfileAdminPromptEditRouteRouteImport
      parentRoute: typeof MainRoute
    }
    '/content/$promptId/success/execution/$executionId/': {
      id: '/content/$promptId/success/execution/$executionId/'
      path: '/success/execution/$executionId'
      fullPath: '/content/$promptId/success/execution/$executionId'
      preLoaderRoute: typeof ContentPromptIdSuccessExecutionExecutionIdIndexRouteImport
      parentRoute: typeof ContentPromptIdRoute
    }
    '/_main/profile/admin/prompt/edit/$promptId': {
      id: '/_main/profile/admin/prompt/edit/$promptId'
      path: '/$promptId'
      fullPath: '/profile/admin/prompt/edit/$promptId'
      preLoaderRoute: typeof MainProfileAdminPromptEditPromptIdRouteRouteImport
      parentRoute: typeof MainProfileAdminPromptEditRouteRoute
    }
    '/_main/profile/admin/prompt/edit/$promptId/': {
      id: '/_main/profile/admin/prompt/edit/$promptId/'
      path: '/'
      fullPath: '/profile/admin/prompt/edit/$promptId/'
      preLoaderRoute: typeof MainProfileAdminPromptEditPromptIdIndexRouteImport
      parentRoute: typeof MainProfileAdminPromptEditPromptIdRouteRoute
    }
  }
}

interface MainProfileAdminPromptEditPromptIdRouteRouteChildren {
  MainProfileAdminPromptEditPromptIdIndexRoute: typeof MainProfileAdminPromptEditPromptIdIndexRoute
}

const MainProfileAdminPromptEditPromptIdRouteRouteChildren: MainProfileAdminPromptEditPromptIdRouteRouteChildren =
  {
    MainProfileAdminPromptEditPromptIdIndexRoute:
      MainProfileAdminPromptEditPromptIdIndexRoute,
  }

const MainProfileAdminPromptEditPromptIdRouteRouteWithChildren =
  MainProfileAdminPromptEditPromptIdRouteRoute._addFileChildren(
    MainProfileAdminPromptEditPromptIdRouteRouteChildren,
  )

interface MainProfileAdminPromptEditRouteRouteChildren {
  MainProfileAdminPromptEditPromptIdRouteRoute: typeof MainProfileAdminPromptEditPromptIdRouteRouteWithChildren
}

const MainProfileAdminPromptEditRouteRouteChildren: MainProfileAdminPromptEditRouteRouteChildren =
  {
    MainProfileAdminPromptEditPromptIdRouteRoute:
      MainProfileAdminPromptEditPromptIdRouteRouteWithChildren,
  }

const MainProfileAdminPromptEditRouteRouteWithChildren =
  MainProfileAdminPromptEditRouteRoute._addFileChildren(
    MainProfileAdminPromptEditRouteRouteChildren,
  )

interface MainRouteChildren {
  MainProfileGenerationsTimelineRoute: typeof MainProfileGenerationsTimelineRoute
  MainCommunityIndexRoute: typeof MainCommunityIndexRoute
  MainProfileIndexRoute: typeof MainProfileIndexRoute
  MainStickersIndexRoute: typeof MainStickersIndexRoute
  MainProfileAdminIndexRoute: typeof MainProfileAdminIndexRoute
  MainProfileNotificationsIndexRoute: typeof MainProfileNotificationsIndexRoute
  MainProfilePurchasesIndexRoute: typeof MainProfilePurchasesIndexRoute
  MainProfileAdminPromptEditRouteRoute: typeof MainProfileAdminPromptEditRouteRouteWithChildren
  MainProfileAdminPromptCreateRoute: typeof MainProfileAdminPromptCreateRoute
  MainProfileAdminPromptIndexRoute: typeof MainProfileAdminPromptIndexRoute
}

const MainRouteChildren: MainRouteChildren = {
  MainProfileGenerationsTimelineRoute: MainProfileGenerationsTimelineRoute,
  MainCommunityIndexRoute: MainCommunityIndexRoute,
  MainProfileIndexRoute: MainProfileIndexRoute,
  MainStickersIndexRoute: MainStickersIndexRoute,
  MainProfileAdminIndexRoute: MainProfileAdminIndexRoute,
  MainProfileNotificationsIndexRoute: MainProfileNotificationsIndexRoute,
  MainProfilePurchasesIndexRoute: MainProfilePurchasesIndexRoute,
  MainProfileAdminPromptEditRouteRoute:
    MainProfileAdminPromptEditRouteRouteWithChildren,
  MainProfileAdminPromptCreateRoute: MainProfileAdminPromptCreateRoute,
  MainProfileAdminPromptIndexRoute: MainProfileAdminPromptIndexRoute,
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

interface StickerPacksStickerPackIdRouteChildren {
  StickerPacksStickerPackIdCheckoutRoute: typeof StickerPacksStickerPackIdCheckoutRoute
  StickerPacksStickerPackIdSuccessRoute: typeof StickerPacksStickerPackIdSuccessRoute
  StickerPacksStickerPackIdIndexRoute: typeof StickerPacksStickerPackIdIndexRoute
  StickerPacksStickerPackIdDetailsIndexRoute: typeof StickerPacksStickerPackIdDetailsIndexRoute
  StickerPacksStickerPackIdReviewIndexRoute: typeof StickerPacksStickerPackIdReviewIndexRoute
  StickerPacksStickerPackIdSelectNftsIndexRoute: typeof StickerPacksStickerPackIdSelectNftsIndexRoute
  StickerPacksStickerPackIdSelectTierIndexRoute: typeof StickerPacksStickerPackIdSelectTierIndexRoute
  StickerPacksStickerPackIdProcessingExecutionIdIndexRoute: typeof StickerPacksStickerPackIdProcessingExecutionIdIndexRoute
}

const StickerPacksStickerPackIdRouteChildren: StickerPacksStickerPackIdRouteChildren =
  {
    StickerPacksStickerPackIdCheckoutRoute:
      StickerPacksStickerPackIdCheckoutRoute,
    StickerPacksStickerPackIdSuccessRoute:
      StickerPacksStickerPackIdSuccessRoute,
    StickerPacksStickerPackIdIndexRoute: StickerPacksStickerPackIdIndexRoute,
    StickerPacksStickerPackIdDetailsIndexRoute:
      StickerPacksStickerPackIdDetailsIndexRoute,
    StickerPacksStickerPackIdReviewIndexRoute:
      StickerPacksStickerPackIdReviewIndexRoute,
    StickerPacksStickerPackIdSelectNftsIndexRoute:
      StickerPacksStickerPackIdSelectNftsIndexRoute,
    StickerPacksStickerPackIdSelectTierIndexRoute:
      StickerPacksStickerPackIdSelectTierIndexRoute,
    StickerPacksStickerPackIdProcessingExecutionIdIndexRoute:
      StickerPacksStickerPackIdProcessingExecutionIdIndexRoute,
  }

const StickerPacksStickerPackIdRouteWithChildren =
  StickerPacksStickerPackIdRoute._addFileChildren(
    StickerPacksStickerPackIdRouteChildren,
  )

interface StickerPacksRouteChildren {
  StickerPacksStickerPackIdRoute: typeof StickerPacksStickerPackIdRouteWithChildren
  StickerPacksIndexRoute: typeof StickerPacksIndexRoute
  StickerPacksGeneratedIdIndexRoute: typeof StickerPacksGeneratedIdIndexRoute
}

const StickerPacksRouteChildren: StickerPacksRouteChildren = {
  StickerPacksStickerPackIdRoute: StickerPacksStickerPackIdRouteWithChildren,
  StickerPacksIndexRoute: StickerPacksIndexRoute,
  StickerPacksGeneratedIdIndexRoute: StickerPacksGeneratedIdIndexRoute,
}

const StickerPacksRouteWithChildren = StickerPacksRoute._addFileChildren(
  StickerPacksRouteChildren,
)

interface ContentPromptIdRouteChildren {
  ContentPromptIdIndexRoute: typeof ContentPromptIdIndexRoute
  ContentPromptIdProcessingExecutionIdRoute: typeof ContentPromptIdProcessingExecutionIdRoute
  ContentPromptIdDetailsIndexRoute: typeof ContentPromptIdDetailsIndexRoute
  ContentPromptIdInvitationIndexRoute: typeof ContentPromptIdInvitationIndexRoute
  ContentPromptIdSelectNftsIndexRoute: typeof ContentPromptIdSelectNftsIndexRoute
  ContentPromptIdSuccessExecutionExecutionIdIndexRoute: typeof ContentPromptIdSuccessExecutionExecutionIdIndexRoute
}

const ContentPromptIdRouteChildren: ContentPromptIdRouteChildren = {
  ContentPromptIdIndexRoute: ContentPromptIdIndexRoute,
  ContentPromptIdProcessingExecutionIdRoute:
    ContentPromptIdProcessingExecutionIdRoute,
  ContentPromptIdDetailsIndexRoute: ContentPromptIdDetailsIndexRoute,
  ContentPromptIdInvitationIndexRoute: ContentPromptIdInvitationIndexRoute,
  ContentPromptIdSelectNftsIndexRoute: ContentPromptIdSelectNftsIndexRoute,
  ContentPromptIdSuccessExecutionExecutionIdIndexRoute:
    ContentPromptIdSuccessExecutionExecutionIdIndexRoute,
}

const ContentPromptIdRouteWithChildren = ContentPromptIdRoute._addFileChildren(
  ContentPromptIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MainRoute: MainRouteWithChildren,
  AboutRoute: AboutRoute,
  ConstraintsRoute: ConstraintsRoute,
  StickerPacksRoute: StickerPacksRouteWithChildren,
  AuthRefreshRoute: AuthRefreshRoute,
  ContentPromptIdRoute: ContentPromptIdRouteWithChildren,
  Demo2IndexRoute: Demo2IndexRoute,
  Demo3IndexRoute: Demo3IndexRoute,
  PostIndexRoute: PostIndexRoute,
  PrivateIndexRoute: PrivateIndexRoute,
  SelectCommunityIndexRoute: SelectCommunityIndexRoute,
  Demo2ItemIndexRoute: Demo2ItemIndexRoute,
  PostPostIdIndexRoute: PostPostIdIndexRoute,
  PostCreateIndexRoute: PostCreateIndexRoute,
  PostCreateImageIndexRoute: PostCreateImageIndexRoute,
  PostCreateStickerIndexRoute: PostCreateStickerIndexRoute,
  PostCreateVideoIndexRoute: PostCreateVideoIndexRoute,
  AuthDiscordV1CallbackIndexRoute: AuthDiscordV1CallbackIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
